export default {
    ENV: store => store.system.env,
    FRAMED: store => store.system.framed,
    SPINNER: store => store.spinner
};
